// extracted by mini-css-extract-plugin
module.exports = {"buttonXsNeutral":"ButtonXsNeutral_buttonXsNeutral__25H5D"};